import React, {ReactElement} from "react";
import {StyledBoxRow, StyledContainer, StyledEmpty, StyledMarkdown} from "../../shared/StyledComponents";
import {BaseShowcaseFragment} from "../BaseShowcaseFragment";
import {Settings, SOCIALS_TYPE_METADATAS, SocialsType} from "../settings";
import {IconButton} from "@mui/material";
import {MoreHorizOutlined} from "@mui/icons-material";
import {PD_XLG2} from "../../shared/dimens";

function SocialsButton(props: { type: SocialsType, url: string }): ReactElement {
  const metadata = SOCIALS_TYPE_METADATAS.findMetadata(props.type);
  return <IconButton onClick={() => window.open(props.url, "_blank")}>
    <metadata.iconType style={{fontSize: "125%"}}/>
  </IconButton>
}

export class AboutFragment extends BaseShowcaseFragment {

  protected renderPageContent(): React.ReactElement | null {
    const socials = Settings.getInstance().socials;
    const metadata = this.state.userProfile.metadata;
    const about = metadata?.about;
    return <StyledContainer style={{padding: "16%", alignItems:"center", gap: PD_XLG2}}>
      {about
        ? <>
          <StyledBoxRow>
            {socials.x ? <SocialsButton type={SocialsType.X} url={socials.x}/> : null}
            {socials.facebook ? <SocialsButton type={SocialsType.FACEBOOK} url={socials.facebook}/> : null}
            {socials.instagram ? <SocialsButton type={SocialsType.INSTAGRAM} url={socials.instagram}/> : null}
            {socials.github ? <SocialsButton type={SocialsType.GITHUB} url={socials.github}/> : null}
            {socials.youtube ? <SocialsButton type={SocialsType.YOUTUBE} url={socials.youtube}/> : null}
          </StyledBoxRow>
          <StyledMarkdown style={{textAlign: "center"}}>{about}</StyledMarkdown>
        </>
        : <StyledEmpty emptyConfig={{
          title: "Nothing to show here.",
          iconType: MoreHorizOutlined,
        }}/>
      }
    </StyledContainer>
  }
}